import { render, staticRenderFns } from "./RatesDropDetails.vue?vue&type=template&id=4ed2a380&scoped=true&"
import script from "./RatesDropDetails.vue?vue&type=script&lang=js&"
export * from "./RatesDropDetails.vue?vue&type=script&lang=js&"
import style0 from "./RatesDropDetails.vue?vue&type=style&index=0&id=4ed2a380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed2a380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ed2a380')) {
      api.createRecord('4ed2a380', component.options)
    } else {
      api.reload('4ed2a380', component.options)
    }
    module.hot.accept("./RatesDropDetails.vue?vue&type=template&id=4ed2a380&scoped=true&", function () {
      api.rerender('4ed2a380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/RatesDropDetails.vue"
export default component.exports